import { FormLabel } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import moment from "moment";
import { useTranslation } from "react-i18next";

import "./DeliveryDatePicker.scss";

interface DeliveryDatePickerProps {
  selectedDateTime: Date | null;
  onChange?(dateTime: Date | null): void;
}

const DeliveryDatePicker = (props: DeliveryDatePickerProps) => {
  const { selectedDateTime, onChange } = props;
  const { t } = useTranslation();

  return (
    <div className="delivery-date-picker">
      <FormLabel required>{t("plannedDelivery")}</FormLabel>
      <DateTimePicker
        className="input-element"
        ampm={false}
        value={selectedDateTime}
        //format={t("dateTimeYearFormat")}
        onChange={onChange}
        onAccept={onChange}
        disablePast
        minDateTime={new Date()}
        maxDateTime={moment(new Date()).add(6, "months").toDate()}
        minutesStep={15}
      />
    </div>
  );
};

export default DeliveryDatePicker;
